import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
import type {
  OverrideOrderMilesMutation,
  OverrideOrderMilesMutationVariables,
} from "@api/graphql/generated/generated-types";

const OVERRIDE_ORDER_MILES_MUTATION = gql`
  mutation overrideOrderMiles($courierId: ID!, $orderId: ID!, $milesOverride: Float) {
    overrideOrderMiles(
      courierId: $courierId
      orderId: $orderId
      milesOverride: $milesOverride
    ) {
      id
      milesOverride
    }
  }
`;

export function useOverrideOrderMiles(
  options?: Apollo.MutationHookOptions<
    OverrideOrderMilesMutation,
    OverrideOrderMilesMutationVariables
  >
) {
  return Apollo.useMutation<OverrideOrderMilesMutation, OverrideOrderMilesMutationVariables>(
    OVERRIDE_ORDER_MILES_MUTATION,
    options
  );
}
